// extracted by mini-css-extract-plugin
export default {"base":"Block__base___Hd2zuxJV","elevated":"Block__elevated___zRp3I49m"};